// Keep public search queries bounded so inputs, URLs, and API requests stay predictable.
export const MAX_SEARCH_QUERY_LENGTH = 100;
